module.exports = __webpack_public_path__ + "components/flag/static/square/im-8239fa0b096a57b15c9509c297fa6736.svg";